import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59af0344")

_pushScopeId("data-v-59af0344")
const _hoisted_1 = { class: "reportConfirm_reportItem" }
const _hoisted_2 = { class: "reportConfirm_reportItem_box reportConfirm_reportItem_show" }
const _hoisted_3 = { class: "reportComfirm_title_flex" }
const _hoisted_4 = { class: "reportConfirm_reportItem_detectNum" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("去修改 ")
const _hoisted_6 = {
  key: 0,
  class: "reportConfirm_reportPicItem_box"
}
const _hoisted_7 = { class: "reportConfirm_reportPics" }
const _hoisted_8 = { class: "reportConfirm_reportPics_item_img" }
const _hoisted_9 = {
  key: 1,
  class: "reportConfirm_reportTips"
}
const _hoisted_10 = { class: "reportConfirm_reportItem_box reportConfirm_reportItem_hide" }
const _hoisted_11 = {
  key: 0,
  class: "reportConfirm_reportItem_detectNum"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_reportComfirmTitle, {
      titleTxt: _ctx.renderData.itemTitle,
      isShowRight: _ctx.renderData.itemTitle === "环车检测",
      goPageType: _ctx.renderData.itemTitle === "环车检测" ? "huanchejian" : ""
    }, null, 8, ["titleTxt", "isShowRight", "goPageType"]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderData.itemList, (item) => {
        return _withDirectives((_openBlock(), _createBlock("div", {
          class: "reportConfirm_reportItem_box_item",
          key: item.code
        }, [
          _createVNode("p", _hoisted_3, [
            _createVNode("span", {
              class: ["reportConfirm_reportItem_detect", {"cGray": item.name === "无此部件" || item.name === "受限不可检"}]
            }, [
              _createVNode("b", _hoisted_4, _toDisplayString(item.itemCount), 1),
              _createTextVNode(_toDisplayString(item.name), 1)
            ], 2),
            (_ctx.renderData.itemTitle === "自由检测")
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "reportComfirm_title_titArrow",
                  onClick: ($event: any) => (_ctx.goPage(item.name))
                }, [
                  _hoisted_5,
                  _createVNode(_component_van_icon, { name: "arrow" })
                ], 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          (item.name !== "无此部件" && item.name !== "受限不可检")
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.itemList, (items) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "reportConfirm_reportPics_item",
                      key: items.photoId
                    }, [
                      _createVNode("div", _hoisted_8, [
                        (items.bigPhotoPath)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: items.bigPhotoPath,
                              alt: "",
                              srcset: ""
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode("span", null, _toDisplayString(items.defectRemark.split(':')[1]), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(items.defectRemark.split(':')[0]), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (item.name === "无此部件" || item.name === "受限不可检")
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.itemList, (items) => {
                  return (_openBlock(), _createBlock("p", {
                    key: items.defectRemark
                  }, _toDisplayString(items.defectRemark), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 512)), [
          [_vShow, item.itemCount>0]
        ])
      }), 128)),
      _createVNode("div", null, [
        _createVNode("span", {
          class: "reportConfirm_lookMore",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showOrHide && _ctx.showOrHide(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.state.isShowMore ? '收起' : '展开') + " ", 1),
          _withDirectives(_createVNode(_component_van_icon, { name: "arrow-down" }, null, 512), [
            [_vShow, !_ctx.state.isShowMore]
          ]),
          _withDirectives(_createVNode(_component_van_icon, { name: "arrow-up" }, null, 512), [
            [_vShow, _ctx.state.isShowMore]
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.isShowMore]
    ]),
    _withDirectives(_createVNode("div", _hoisted_10, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderData.itemList, (item) => {
        return _withDirectives((_openBlock(), _createBlock("span", {
          class: ["reportConfirm_reportItem_detect", {"cGray": item.name === "无此部件" || item.name === "受限不可检"}],
          key: item.code
        }, [
          (item.itemCount>0 || (item.name === '无此部件' || item.name === '受限不可检') )
            ? (_openBlock(), _createBlock("b", _hoisted_11, _toDisplayString(item.itemCount), 1))
            : (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                name: "checked",
                class: "cGreen"
              })),
          _createTextVNode(" " + _toDisplayString(item.name), 1)
        ], 2)), [
          [_vShow, (item.name !== "无此部件" && item.name !== "受限不可检") || ((item.name === "无此部件" || item.name === "受限不可检") && item.itemCount>0)]
        ])
      }), 128)),
      _createVNode("span", {
        class: "reportConfirm_lookMore",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showOrHide && _ctx.showOrHide(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.state.isShowMore ? '收起' : '展开') + " ", 1),
        _withDirectives(_createVNode(_component_van_icon, { name: "arrow-down" }, null, 512), [
          [_vShow, !_ctx.state.isShowMore]
        ]),
        _withDirectives(_createVNode(_component_van_icon, { name: "arrow-up" }, null, 512), [
          [_vShow, _ctx.state.isShowMore]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.state.isShowMore]
    ])
  ]))
})